export default "__VITE_ASSET__BWniBhue__"